import { Eye, Send } from "lucide-react";
import { Label } from "@/components/ui/label";
import {
  RadioCard,
  RadioCardContent,
  RadioCardDescription,
  RadioCardItem,
  RadioGroup,
} from "@/components/ui/radio-group";

export type MessagingMode = "automatic" | "approval";

/** Automatic vs approval-required sending — the create wizard and the Messaging settings page. */
export function MessagingModeRadio({
  value,
  onValueChange,
  disabled,
}: {
  value: MessagingMode;
  onValueChange: (value: MessagingMode) => void;
  disabled?: boolean;
}) {
  return (
    <RadioGroup
      value={value}
      onValueChange={(v) => onValueChange(v as MessagingMode)}
      disabled={disabled}
      className="lg:grid-cols-2"
    >
      <RadioCard className="gap-3 bg-background hover:bg-muted">
        <Send />
        <RadioCardContent>
          <Label htmlFor="messaging-automatic">
            Automatic
            <span className="text-muted-foreground text-xs">(Recommended)</span>
          </Label>
          <RadioCardDescription id="messaging-automatic-description">
            Amy writes and sends emails automatically on your behalf.
          </RadioCardDescription>
        </RadioCardContent>
        <RadioCardItem
          value="automatic"
          id="messaging-automatic"
          aria-describedby="messaging-automatic-description"
        />
      </RadioCard>
      <RadioCard className="gap-3 bg-background hover:bg-muted">
        <Eye />
        <RadioCardContent>
          <Label htmlFor="messaging-approval">Approval Required</Label>
          <RadioCardDescription id="messaging-approval-description">
            Amy only drafts emails for you to review & approve before sending.
          </RadioCardDescription>
        </RadioCardContent>
        <RadioCardItem
          value="approval"
          id="messaging-approval"
          aria-describedby="messaging-approval-description"
        />
      </RadioCard>
    </RadioGroup>
  );
}
